module.exports = __webpack_public_path__ + "static/media/desktop_illustration_side6_side1_xmas.e587de61.png";